import { ReactFlowInstance, Node, Edge } from "@xyflow/react";
import { RJSFSchema } from "@rjsf/utils";

/**
 * Delete workflow node and all child nodes and edges
 * @param context
 * @param reactFlowInstance
 */
export function processNodeDelete(context: any, reactFlowInstance: ReactFlowInstance): void {
    let nodes: Node[] = context.nodes;
    let newNodes: Node[] = [];
    for (const node of nodes) {
        if (!node.id.includes(context.activeEditHQUploadNode.id)) {
            newNodes.push(node);
        }
    }

    let edges: Edge[] = context.edges;
    let newEdges: Edge[] = [];
    for (const edge of edges) {
        if (!edge.id.includes(context.activeEditHQUploadNode.id)) {
            newEdges.push(edge);
        }
    }

    context.updateLayoutNodes(newNodes);
    context.updateLayoutEdges(newEdges);
}


export function processNodeFormSubmit(context: any, formData: any, reactFlowInstance: ReactFlowInstance): void {
    // debugger;
    let editNode: Node = context.activeEditHQUploadNode;
    if (editNode === undefined) {
        return;
    }
    editNode.data = formData;

    let allNodes: Node[] = reactFlowInstance.getNodes();
    let newNodes: Node[] = [];
    let activeIds: any[] = [];
    for (const node of allNodes) {
        if (!activeIds.includes(node.id)) {
            activeIds.push(node.id);
            newNodes.push(node);
        }
    }

    let updatedNodes = [editNode];
    for (const node of newNodes) {
        if (node.id !== editNode.id) {
            updatedNodes.push(node);
        }
    }
    ;
    reactFlowInstance.updateNodeData(editNode.id, formData);
    context.updateLayoutNodes(updatedNodes);

}

export const formSchema: RJSFSchema = {
    title: '',
    type: 'object',
    required: [],
    properties: {
        'data_input': {
            title: 'Data Input',
            type: 'string',
            description: 'Location of data to update',
            default: 'default'
        },
        entity_or_action: {
            title: 'Entity or Action',
            type: 'string',
            enum: [
                'Entity',
                'NokNok Action'
            ],
            default: 'Entity'
        },
        // entity: {
        //     title: 'Entity',
        //     type: 'string',
        //     enum: [
        //         'Customer (not available yet)',
        //         'Company',
        //         'Website',
        //         'Url',
        //         'Contacts',
        //         'Emails',
        //         'Telephone Numbers',
        //         'Address',
        //         'Social Media',
        //         'Employees',
        //     ],
        //     default: 'Customer (not available yet)'
        // },


        'data_management': {
            title: 'Data Store',
            type: 'string',
            description: 'Location to store update response',
            default: 'default'
        },
        add_output_to_message: {
            title: 'Add Output To Messages',
            type: 'boolean',
            default: false,
            description: 'Store output as a message to keep in the message history as well as Data store',
        }
    },
    allOf: [


        {
            if: {
                properties: {
                    entity_or_action: {
                        const: 'Entity'
                    }
                }
            },
            then: {
                properties: {
                    entity_data: {
                        title: '',
                        type: 'object',
                        properties: {
                            entity_type: {
                                title: 'Entity Type',
                                type: 'string',
                                enum: [
                                    'Customer (not available yet)',
                                    'Company',
                                    'Website',
                                    'Url',
                                    'Contacts',
                                    'Emails',
                                    'Telephone Numbers',
                                    'Address',
                                    'Social Media',
                                    'Employees',
                                ],
                                default: 'Customer (not available yet)'
                            },
                        },
                    }
                }
            }
        },
        {
            if: {
                properties: {
                    entity_or_action: {
                        const: 'NokNok Action'
                    }
                }
            },
            then: {
                properties: {
                    custom_action: {
                        title: 'NokNok Action',
                        type: 'string',
                        enum: [
                            'Update EmailFinder Start Running',
                            'Update EmailFinder Completed',
                            'Update Operator Availability Down',
                            'Do All The Things',
                        ],
                        default: 'Update EmailFinder Start Running'
                    }
                },
            }
        },

        {
            if: {
                properties: {
                    data_management: {
                        const: 'messages'
                    }
                }
            },
            then: {
                properties: {
                    add_output_to_message: {
                        readOnly: true,
                    }
                }
            }
        }
    ]
}

export const nodeDescription: string = "This node is used to update an HQ entity.\n";

